/**
 * article-toc.js
 * Builds a Table of Contents from h2/h3 headings inside the article body.
 * Triggered on DOMContentLoaded. Reads config from data attributes on the
 * TOC container element rendered by the article-custom section.
 */
(function () {
  'use strict';

  function slugify(text) {
    return text
      .toLowerCase()
      .replace(/[^\w\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .trim()
      .slice(0, 80);
  }

  function buildToc() {
    var container = document.querySelector('[data-article-toc]');
    if (!container) return;

    var showH3      = container.dataset.showH3 !== 'false';
    var minHeadings = parseInt(container.dataset.minHeadings, 10) || 2;
    var titleText   = container.dataset.title || 'In This Article';
    var body        = document.querySelector('[itemprop="articleBody"]');

    if (!body) return;

    var selector = showH3 ? 'h2, h3' : 'h2';
    var headings  = Array.prototype.slice.call(body.querySelectorAll(selector));

    // Filter out headings that are clearly UI elements (FAQ accordions etc.)
    headings = headings.filter(function (h) {
      return !h.closest('.article-faq-section') && !h.closest('[data-faq]');
    });

    if (headings.length < minHeadings) {
      container.style.display = 'none';
      return;
    }

    // Assign IDs to headings that don't have one
    var usedIds = {};
    headings.forEach(function (h) {
      if (!h.id) {
        var base = slugify(h.textContent);
        var id   = base;
        var n    = 1;
        while (usedIds[id] || document.getElementById(id)) {
          id = base + '-' + n;
          n++;
        }
        h.id = id;
      }
      usedIds[h.id] = true;
    });

    // Build TOC markup
    var titleEl = document.createElement('p');
    titleEl.className = 'article-toc__title';
    titleEl.textContent = titleText;

    var ol = document.createElement('ol');
    ol.className = 'article-toc__list';

    headings.forEach(function (h) {
      var li = document.createElement('li');
      li.className = 'article-toc__item article-toc__item--' + h.tagName.toLowerCase();

      var a = document.createElement('a');
      a.href      = '#' + h.id;
      a.className = 'article-toc__link';
      a.textContent = h.textContent.trim();

      // Smooth scroll
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var target = document.getElementById(h.id);
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          // Update URL hash without jumping
          history.pushState(null, '', '#' + h.id);
        }
      });

      li.appendChild(a);
      ol.appendChild(li);
    });

    container.innerHTML = '';
    container.appendChild(titleEl);
    container.appendChild(ol);
    container.style.display = 'block';

    // Highlight active heading on scroll
    var tocLinks = Array.prototype.slice.call(ol.querySelectorAll('.article-toc__link'));
    if (tocLinks.length === 0) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var id = entry.target.id;
            tocLinks.forEach(function (link) {
              link.classList.toggle('article-toc__link--active', link.getAttribute('href') === '#' + id);
            });
          }
        });
      },
      { rootMargin: '0px 0px -60% 0px', threshold: 0 }
    );

    headings.forEach(function (h) { observer.observe(h); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildToc);
  } else {
    buildToc();
  }
})();
